import {
  Button,
  Card,
  CardMedia,
  Container,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import EcoIcon from '@material-ui/icons/Eco';
import ComputerIcon from '@material-ui/icons/Computer';
import DomainIcon from '@material-ui/icons/Domain';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import {screenReaderOnly} from '../../utils/screenReaderOnly';

const defaultSplashImage = 'meterhero.png';

const useStyles = makeStyles(({spacing, breakpoints}) => ({
  root: {
    backgroundColor: ' #d9d9d9ff',
    paddingBottom: '5px',
    [breakpoints.down('md')]: {
      width: 'fit-content',
    },
  },
  container: {
    minWidth: '100%',
    color: 'white',
  },
  section: {
    margin: 'auto',
    width: 'fit-content',
    minHeight: '100vh',
    paddingTop: '4em',
  },
  splashImageCard: {
    width: 'fit-content',
  },
  splashImageCardMedia: {
    width: 'unset',
    maxHeight: '60vh',
    height: 'auto',
    objectFit: 'contain',
    maxWidth: '100%',
  },
  sponsorsLinks: {
    margin: '10px auto 5px',
    display: 'flex',
    flexDirection: 'column',
  },
  sponsorLinkRows: {
    display: 'inline-flex',
    margin: '0 auto',
    '& > *': {
      margin: spacing(1),
    },
  },
}));

export function SplashPage({user, sponsor}) {
  const classes = useStyles();

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const buttonProps = {
    size: isSmallScreen ? 'small' : 'large',
    target: '_blank',
    rel: 'noopener noreferrer',
    variant: 'contained',
    color: 'primary',
  };

  const ImageLinkUrl = sponsor.splashImage
    ? sponsor.splashImage.uri
      ? sponsor.splashImage.uri
      : defaultSplashImage
    : defaultSplashImage;

  return (
    <Container disableGutters maxWidth={false} className={classes.root}>
      <Container component="div" className={classes.container}>
        <Container component="div" className={classes.section}>
          <h1 style={screenReaderOnly()}>
            Welcome to MeterHero
          </h1>
          <Card className={classes.splashImageCard}>
            <CardMedia
              className={classes.splashImageCardMedia}
              component="img"
              image={ImageLinkUrl}
              alt="Image that communicates the importance of saving water and or energy in your local area"
            />
          </Card>
          <div className={classes.sponsorsLinks}>
            <div className={classes.sponsorLinkRows}>
              {sponsor.aboutUrl && (
                  <Button
                    {...buttonProps}
                    href={sponsor.aboutUrl}
                    startIcon={<InfoIcon />}
                    aria-label="Local Utility (opens in new window)"
                  >
                    <span style={{flex: 'none'}}>LOCAL UTILITY</span>
                  </Button>
              )}
              {sponsor.about2Url && (
                <Button
                  {...buttonProps}
                  href={sponsor.about2Url}
                  startIcon={<InfoIcon />}
                  aria-label="Local Utility (opens in new window)"
                >
                  <span style={{flex: 'none'}}>LOCAL UTILITY</span>
                </Button>
              )}
              {sponsor.regionalAboutUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.regionalAboutUrl}
                  startIcon={<AccountBalanceIcon />}
                  aria-label="Regional Provider (opens in new window)"
                >
                  <span style={{flex: 'none'}}>REGIONAL PROVIDER</span>
                </Button>
              )}
            </div>
            <div className={classes.sponsorLinkRows}>
              {sponsor.tourUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.tourUrl}
                  startIcon={<ComputerIcon />}
                  aria-label="Virtual Tour (opens in new window)"
                >
                  <span style={{flex: 'none'}}>VIRTUAL TOUR</span>
                </Button>
              )}
              {sponsor.programsUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.programsUrl}
                  startIcon={<EcoIcon />}
                  aria-label="Conservation Programs (opens in new window)"
                >
                  <span style={{flex: 'none'}}>CONSERVATION PROGRAMS</span>
                </Button>
              )}
            </div>
            <div className={classes.sponsorLinkRows}>
              {sponsor.careersUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.careersUrl}
                  startIcon={<DomainIcon />}
                  aria-label="Careers (opens in new window)"
                >
                  <span style={{flex: 'none'}}>CAREERS</span>
                </Button>
              )}
              {sponsor.socialUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.socialUrl}
                  startIcon={<EmojiPeopleIcon />}
                  aria-label="Social (opens in new window)"
                >
                  <span style={{flex: 'none'}}>SOCIAL</span>
                </Button>
              )}
              {sponsor.websiteUrl && (
                <Button
                  {...buttonProps}
                  href={sponsor.websiteUrl}
                  startIcon={<ComputerIcon />}
                  aria-label="Utility Portal (opens in new window)"
                >
                  <span style={{flex: 'none'}}>UTILITY PORTAL</span>
                </Button>
              )}
            </div>
          </div>
        </Container>
      </Container>
    </Container>
  );
}

SplashPage.propTypes = {
  user: PropTypes.object.isRequired,
};
